import ufeApi from 'services/api/ufeApi';

/**
 *
 * @param {*} profileId
 * @returns
 */
async function getLithiumSSOToken(profileId) {
    const url = `/gway/v2/user/profile/lithiumSSOToken/${profileId}?useNGPFlow=true`;

    const options = { method: 'GET' };

    try {
        const data = await ufeApi.makeRequest(url, options);

        if (data.errorCode) {
            throw data;
        }

        return data.lithiumSsoToken;
    } catch (error) {
        Sephora.logger.verbose('FAILED TO GET LITHIUM TOKEN', error);
        throw new Error(error);
    }
}

export default getLithiumSSOToken;
